export default __webpack_public_path__ + "static/media/duy.57ea8d88.png";